import styled from 'styled-components';

export const StyledMedicalLeaveDocumentErrorsStatusContent = styled.ol`
   color: ${(props) => props.theme.textBody};
   padding: 0;
   margin: 0 0 0 14px;
`;
StyledMedicalLeaveDocumentErrorsStatusContent.displayName = 'StyledMedicalLeaveDocumentErrorsStatusContent';
